// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__cfVWF","label":"styles_label__l_jrv","icon":"styles_icon__K3amx"};